export default __webpack_public_path__ + "static/media/QRtien.1114847e.png";